<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="right-info">
      СНиП 3.04.03-85<br>
      ЗАЩИТА СТРОИТЕЛЬНЫХ  КОНСТРУКЦИЙ И<br>
      СООРУЖЕНИЙ ОТ КОРРОЗИИ<br>
      <br>
      Приложение 1<br>
      обязательное
    </div>
    <div class="chapter-title">ЖУРНАЛ ПРОИЗВОДСТВА АНТИКОРРОЗИОННЫХ РАБОТ</div>
    <n-items v-if="project">
      <n-input title="Наименование объекта" v-bind="$form.input('title')" :text="!editable" />
      <n-input title="Основание для выполнения работ (договор, наряд)" v-bind="$form.input('work')" :text="!editable" />
      <n-input title="Производитель работ" v-bind="$form.input('executor')" :text="!editable" />
      <n-input title="Начало " v-bind="$form.input('startedAt')" :text="!editable" />
      <n-input title="Окончание" v-bind="$form.input('endedAt')" :text="!editable" />
      <div>В журнале пронумеровано <n-input v-bind="$form.input('pageCount')" :text="!editable" /> страниц</div>
      <div>
        Место печати<br>
        Подпись администрации организации, выдавшей журнал
      </div>
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
  </div>
</template>

<script>
export default {
  name: 'MainChapter1',
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
  }),
  created() {
    this.$form.init(this.journal.data)
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, this.journal.name, this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
